import { lazy } from 'react';

export const CalculationPreview = lazy(() =>
    import('./CalculationPreview').then((module) => ({ default: module.CalculationPreview })),
);
